export const PAGE_CONTAINER_ID = 'page-container';
export const BODY_PORTAL_ID = 'body-backdrop-portal';
